export enum AccountStatementSourceType {
  Topup = 'TOPUP',
  BankTransfer = 'BANK_TRANSFER',
  Invoice = 'INVOICE',
  InvoiceReversal = 'INVOICE_REVERSAL',
}

export enum AccountStatementType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}